import React from 'react';
import { Search, Plus, Calculator, Scan, BookOpen, Cloud, ChefHat, ShoppingBasket } from 'lucide-react';
import { useFoodContext } from '../../context';
import { TABS, FEATURE_FLAGS } from '../../utils/constants';

/**
 * Navigation tabs component
 */
const Navigation = () => {
  const { activeTab, setActiveTab } = useFoodContext();

  const tabs = [
    {
      id: TABS.SEARCH,
      label: 'Recherche d\'aliments',
      icon: Search,
      color: 'green'
    },
    {
      id: TABS.OPEN_FOOD_FACTS,
      label: 'Open Food Facts',
      icon: Scan,
      color: 'blue'
    },
    {
      id: TABS.CALCULATOR,
      label: 'Calculateur de repas',
      icon: Calculator,
      color: 'purple'
    },
    {
      id: TABS.ADD,
      label: 'Ajouter un aliment',
      icon: Plus,
      color: 'orange'
    },
    {
      id: TABS.RECIPES,
      label: 'Recettes',
      icon: ChefHat,
      color: 'orange'
    },
    {
      id: TABS.PANTRY,
      label: 'Mon Frigo',
      icon: ShoppingBasket,
      color: 'green'
    },
    {
      id: TABS.GUIDE,
      label: 'Guide diabétique',
      icon: BookOpen,
      color: 'indigo'
    },
    ...(FEATURE_FLAGS.GOOGLE_DRIVE_SYNC ? [{
      id: TABS.SYNC,
      label: 'Synchronisation',
      icon: Cloud,
      color: 'green'
    }] : [])
  ];

  const getTabClasses = (tab) => {
    const isActive = activeTab === tab.id || (tab.id === TABS.RECIPES && activeTab === TABS.RECIPE_VIEW);
    const baseClasses = 'px-6 py-3 rounded-full font-medium transition-all flex items-center gap-2';

    if (isActive) {
      return `${baseClasses} bg-${tab.color}-600 text-white shadow-lg`;
    }

    return `${baseClasses} bg-white text-gray-600 hover:bg-${tab.color}-50`;
  };

  return (
    <div className="flex flex-wrap gap-2 mb-8 justify-center">
      {tabs.map((tab) => {
        const Icon = tab.icon;
        return (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={getTabClasses(tab)}
            aria-label={tab.label}
          >
            <Icon className="w-4 h-4" />
            <span className="hidden sm:inline">{tab.label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default Navigation;